<template>
  <base-section
    id="venice"
    style="padding-bottom: 0px !important"
  >
    <base-section-heading title="City of Venice">
      Venezia is a city in northeastern Italy and the capital of the Veneto region. It is built on a group of 118 small islands that are separated by canals and linked by over 400 bridges. The islands are in the shallow Venetian Lagoon, an enclosed bay lying between the mouths of the Po and the Piave rivers. In 2020, 258,685 people resided in the Comune di Venezia, of whom around 55,000 live in the historical city of Venice (centro storico).
    </base-section-heading>
    <v-container>
      <base-section-heading>
      <v-carousel
        cycle
        height="400"
        hide-delimiter-background
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
          :src="slide.src"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          />
        </v-carousel-item>
      </v-carousel>
      </base-section-heading>
      <br>
      <br>
      <base-section-heading
        divider="null"
      >
        The name is derived from the ancient Veneti people who inhabited the region by the 10th century BC. The city was historically the capital of the Republic of Venice for over a millennium, from 697 to 1797. It was a major financial and maritime power during the Middle Ages and Renaissance, and a staging area for the Crusades and the Battle of Lepanto, as well as an important center of commerce—especially silk, grain, and spice, and of art from the 13th century to the end of the 17th. The city-state of Venice is considered to have been the first real international financial center, emerging in the 9th century and reaching its greatest prominence in the 14th century. This made Venice a wealthy city throughout most of its history. After the Napoleonic Wars and the Congress of Vienna, the Republic was annexed by the Austrian Empire, until it became part of the Kingdom of Italy in 1866, following a referendum held as a result of the Third Italian War of Independence. Although the city is facing some challenges, Venice remains a very popular tourist destination, a major cultural center, and has been ranked many times the most beautiful city in the world. It has been described by the Times Online as one of Europe's most romantic cities and by The New York Times as "undoubtedly the most beautiful city built by man".
      </base-section-heading>
      <br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in venuefooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < venuefooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    data () {
      return {
        isMobile: false,
        venuefooter: [
          {
            name: 'City of Venice',
            url: 'venice',
          },
          {
            name: 'Congress Center',
            url: 'congress-center',
          },
          {
            name: 'Hotel Rooms',
            url: 'hotel-rooms',
          },
          {
            name: 'Visa',
            url: 'visa',
          },
        ],
        slides: [
          {
            src: require('@/images/venue/venice-1.png'),
          },
          {
            src: require('@/images/venue/venice-2.jpg'),
          },
          {
            src: require('@/images/venue/venice-3.jpg'),
          },
          {
            src: require('@/images/venue/terrazza-013.jpg'),
          },
          {
            src: require('@/images/venue/vedute-041.jpg'),
          },
          {
            src: require('@/images/venue/venice-4.jpg'),
          },
          {
            src: require('@/images/venue/venice-5.jpg'),
          },
          {
            src: require('@/images/venue/venice-6.jpg'),
          },
        ],
      }
    },
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
